import React, { ComponentPropsWithoutRef } from 'react';
import parse from 'html-react-parser';
import { useIntl } from 'react-intl';
import GIText from './GIText';

interface IGITextIntlProps extends ComponentPropsWithoutRef<'span'> {
  id: string;
  messageId: string;
  shouldParse?: boolean;
  textReplacements?: { [key: string]: any };
}


const GITextIntl: React.FC<IGITextIntlProps> = ({
    id,
    messageId,
    shouldParse = false,
    textReplacements = {},
    ...rest
}) => {
    const intlApi = useIntl();
    const processedMessage = intlApi.formatMessage({ id: messageId }, { ...textReplacements });
    const text = shouldParse ? parse(processedMessage) : processedMessage;

    return (
        <GIText id={id} {...rest}>
            {text}
        </GIText>
    );
};

export default GITextIntl;